import { ActionsProps } from "../types";
import FirstButton from "./FirstButton";
import SecondButton from "./SecondButton";

const Actions = ({
    isLoading,
    hasNoPermission,
    isEditDisabled,
    isInitialStep,
    selectedConfiguration,
    setSelectedConfiguration,
    handleStep,
    handleSubmitCreate,
    handleSubmitEdit
}: ActionsProps) => {
    return (
        <>
            <FirstButton
                isInitialStep={isInitialStep}
                handleStep={handleStep}
                setSelectedConfiguration={setSelectedConfiguration}
                handleSubmitCreate={handleSubmitCreate}
            />

            <SecondButton
                isInitialStep={isInitialStep}
                hasNoPermission={hasNoPermission}
                isEditDisabled={isEditDisabled}
                isLoading={isLoading}
                selectedConfiguration={selectedConfiguration}
                handleStep={handleStep}
                handleSubmitEdit={handleSubmitEdit}
            />
        </>
    );
};

export default Actions;
